module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "canvas"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "title-content"
  }, [_c('div', {
    staticClass: "title-icon"
  }, [_c('i', {
    class: _vm.icone,
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title-text"
  }, [_c('h4', [_vm._v(_vm._s(_vm.titulo))])]), _vm._v(" "), _c('div', {
    staticClass: "title-logo"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logoComTexto),
      expression: "logoComTexto"
    }],
    attrs: {
      "src": require('../../assets/' + _vm.imagemTexto)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.logoComTexto),
      expression: "!logoComTexto"
    }],
    attrs: {
      "src": require('../../assets/' + _vm.imagem)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.texto) + " ")])]), _vm._v(" "), _vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1fe8224","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pagina-erro/index.vue
// module id = W3+9
// module chunks = 5